import { render, staticRenderFns } from "./supplierMt.vue?vue&type=template&id=6c0dfd32"
import script from "./supplierMt.vue?vue&type=script&lang=js"
export * from "./supplierMt.vue?vue&type=script&lang=js"
import style0 from "./supplierMt.vue?vue&type=style&index=0&id=6c0dfd32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports